import React from 'react';
import { motion } from 'framer-motion';

export default function AboutHero() {
  return (
    <section className="relative flex-grow min-h-[80vh] md:min-h-[90vh] w-full">
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img 
          src="/images/Mubs-main-building.jpeg"
          alt="CFSC Launch Event - Building Africa's Climate Resilience"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 mb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            className="text-4xl md:text-6xl font-extrabold text-white leading-tight"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Building Africa's Climate Resilience
          </motion.h1>
          
          <motion.p
            className="mt-6 text-xl text-gray-200 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Together, we empower institutions and individuals with the tools, knowledge, and skills 
            to drive sustainable solutions for Africa's climate challenges.
          </motion.p>
        </div>
      </div>

      <div 
        className="absolute bottom-0 left-0 right-0 h-16 bg-white" 
        style={{ clipPath: 'ellipse(70% 100% at 50% 100%)' }} 
      />
    </section>
  );
}
